import {ButtonLink} from 'components/atoms/LinksAndButtons/ButtonLink';

import {Headline} from 'components/atoms/Text/Headline';
import {Icon} from 'components/atoms/Media/Icon';
import {SiteSpecificContent} from 'components/atoms/SiteSpecificContent';
import {HeadlineLevel, Margin, LOCALE} from 'features/ui/enums';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {getCurrentLocale} from 'features/services/utils/env-helper';

import './style.scss';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';

interface Props {
    headline: string;
    url:string;
}

export const EcoLabel: React.FunctionComponent<Props> = ({headline, url}) => {
    return (
        <div className="eco-label">
            {getCurrentLocale() === LOCALE.SV &&
                <Icon name="swan-eco-label" sizeM/>
            }
            {getCurrentLocale() === LOCALE.NO &&
                <Icon name="swan-eco-label-no" sizeM />
            }
            <SiteSpecificContent showOnFinland>
                <Icon name="swan-eco-label-fi" sizeM />
            </SiteSpecificContent>

            <Headline 
                level={HeadlineLevel.H3}
                margin={Margin.L} 
                className="eco-label__title" 
            >
                {headline}
            </Headline>
            <ButtonLink 
                href={url} 
                buttonColor={ButtonColor.DEFAULT} 
                buttonSize={ButtonSize.DEFAULT} 
                buttonType={ButtonType.GHOST} 
            >
                <FormattedMessage id="jm.components.EcoLabel.readMoreAboutEco" />
            </ButtonLink>
        </div>
    );
};
